import { CUSTOM_DATA_LAYER_PREFIX } from '~/pages/projectDetails/map/customDataLayers.helpers';
import { GEOREFERENCED_MAP_LAYER_PREFIX } from '~/pages/projectDetails/map/georeferencedMapLayers.helpers';
import { isSiteDataLayerId } from './siteDataLayers';

// Shared min/max bounds for Fiber Lit Buildings across TOC + renderer.
// Product decision: treat this layer as available starting at z=16.
export const FIBER_LIT_BUILDINGS_MIN_ZOOM = 16;
export const FIBER_LIT_BUILDINGS_MAX_ZOOM = 18;
export const GEOREFERENCED_MAP_MIN_ZOOM = 12;

// Pin client-side: backend tilesConfig can report a lower bound for this project-scoped
// layer, but TOC availability must match the dedicated renderer.
export const CLIENT_SIDE_LAYER_ZOOM_OVERRIDES: Record<string, { minZoom: number }> = {
  fiberLitBuildings: { minZoom: FIBER_LIT_BUILDINGS_MIN_ZOOM },
};

// 23 ≈ Mapbox max zoom; keeps unconfigured layers below-min by default.
export const DEFAULT_TOC_MIN_ZOOM = 23;

// Override beats tilesConfig (which can report a lower backend minZoom).
export function resolveLayerMinZoom(layerId: string, tilesConfigEntry: { minZoom?: number } | undefined): number {
  // Project custom-data rasters (WMTS) render at every zoom — Mapbox over-zooms past their
  // maxZoom — so they're never "below min". Return 0 so the TOC never greys/mutes the label
  // (the default would treat any unconfigured layer as unavailable until z23).
  if (layerId.startsWith(CUSTOM_DATA_LAYER_PREFIX)) return 0;
  // Matches the minzoom on the geo-referenced map layer in GeoreferencedMapLayers.
  if (layerId.startsWith(GEOREFERENCED_MAP_LAYER_PREFIX)) return GEOREFERENCED_MAP_MIN_ZOOM;

  // Site Data layers render client-side at every zoom and have no tilesConfig entry.
  if (isSiteDataLayerId(layerId)) return 0;

  const override = CLIENT_SIDE_LAYER_ZOOM_OVERRIDES[layerId];
  if (override) return override.minZoom;
  if (tilesConfigEntry?.minZoom !== undefined) return tilesConfigEntry.minZoom;
  return DEFAULT_TOC_MIN_ZOOM;
}
